import { useAddFileStore } from '@/company-portal/add-file/add-file.store';
import type { File } from '@/components/Views/Company/File/file.types';
import type { MaybeRefOrGetter } from 'vue';
import { computed, ref } from 'vue';

export const useUniqueFileRefNumber = (excludeFileId?: MaybeRefOrGetter<File['id']>) => {
    const addFileStore = useAddFileStore();

    const refNumberToCheck = ref('');

    const { checkResult, isChecking } = addFileStore.checkRefNumberIsUnique(refNumberToCheck, excludeFileId);

    const hasAnyMatchingFile = computed(() => !!checkResult.value?.data?.matchingFileId);

    const refNumberIsUnique = computed(() => !isChecking.value && !!refNumberToCheck.value && !hasAnyMatchingFile.value);

    return { refNumberToCheck, refNumberIsUnique };
};
